import { format, parse } from "date-fns";
import {
  Serializers,
  useQueryState as useQueryStateImpl,
  UseQueryStateOptions,
} from "next-usequerystate";
import { arraySetEquality } from "util/util";

// Wrap next-useQueryState so that setting the state back to default
// removes it from URL query params by passing null to useQueryState's setter
export default function useQueryState<T>(
  key: string,
  options: UseQueryStateOptions<T> & {
    defaultValue: T;
  }
): [
  T extends undefined ? (T & {}) | null : T & {},
  (val: (T & {}) | null) => void
] {
  const [val, setVal] = useQueryStateImpl<T>(key, options);
  const wrapperSetVal = async (newVal: (T & {}) | null) => {
    if (
      newVal === null ||
      newVal === options.defaultValue ||
      (Array.isArray(newVal) && arraySetEquality(newVal, val as any[]))
    ) {
      await setVal(null);
    } else {
      await setVal(newVal);
    }
  };
  return [val, wrapperSetVal];
}

export const dayQueryType: Serializers<Date | null> & { defaultValue: any } = {
  parse: (query: string) =>
    query === "" ? null : parse(query, "MM-dd-yyyy", new Date(0)),
  serialize: (date) => (date === null ? "" : format(date, "MM-dd-yyyy")),
  defaultValue: null,
};
